// @ts-strict-ignore
import * as React from 'react';
import { NarrowSConnector } from 'react-svg-connector';
import partition from 'lodash/partition';
import ResizeObserver from 'resize-observer-polyfill';
import { ConnectorContext } from './connector-context';
import styles from './index.module.styl';
type Nodes = {
  parent: React.RefObject<HTMLDivElement>;
  left: React.RefObject<HTMLDivElement>;
  right: React.RefObject<HTMLDivElement>;
};
type Props = {
  refs: Nodes;
  selected?: boolean;
};

/* eslint-disable react/destructuring-assignment */
const Connector = (_ref: Props) => {
  let {
    refs,
    selected
  }: Props = _ref;
  const [position, setPosition] = React.useState({
    startX: null,
    endX: null,
    startY: null,
    endY: null
  });
  let resizeObserver: ResizeObserver;
  const updateConnector = (leftEl: HTMLDivElement, rightEl: HTMLDivElement, parentEl: HTMLDivElement) => {
    if (leftEl && rightEl) {
      const parent = parentEl.getBoundingClientRect();
      const left = leftEl.getBoundingClientRect();
      const right = rightEl.getBoundingClientRect();
      setPosition({
        startX: left.left - parent.left + left.width,
        startY: left.top - parent.top + left.height / 2,
        endX: right.left - parent.left,
        endY: right.top - parent.top + right.height / 2
      });
    }
  };
  React.useEffect(() => {
    var _resizeObserver;
    resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        updateConnector(refs.left.current, refs.right.current, entry.target);
      });
    });
    (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.observe(refs.parent.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  if (position.startX !== null && position.startY !== null && position.endX !== null && position.endY !== null) {
    return <NarrowSConnector startPoint={{
      x: position.startX,
      y: position.startY
    }} endPoint={{
      x: position.endX,
      y: position.endY
    }} stem={23} // container's gap / 2
    roundCorner strokeWidth={1.5} stroke={selected ? "#5028C0" : "#9B9B9B"} />;
  }
  return null;
};
const Connectors = () => {
  const {
    rightRefs,
    leftRef,
    parentRef,
    selectedRef
  } = React.useContext(ConnectorContext);

  // reshuffle the order to have selected ref show up last
  const [selectedRefs, refs] = partition(rightRefs, ref => (selectedRef === null || selectedRef === void 0 ? void 0 : selectedRef.current) && ref.current === (selectedRef === null || selectedRef === void 0 ? void 0 : selectedRef.current));
  return <>
      {[...refs, ...selectedRefs].map(rightRef => {
      return <Connector key={Math.random()} selected={rightRef.current === (selectedRef === null || selectedRef === void 0 ? void 0 : selectedRef.current)} refs={{
        left: leftRef,
        right: rightRef,
        parent: parentRef
      }} />;
    })}
    </>;
};
export const ConnectorWrapper = _ref2 => {
  let {
    children
  } = _ref2;
  const parentRef = React.useRef(null);
  const [leftRef, setLeftRef] = React.useState<React.RefObject<HTMLDivElement>>(null);
  const [rightRefs, setRightRefs] = React.useState<Array<React.RefObject<HTMLDivElement>>>([]);
  const [selectedRef, setSelectedRef] = React.useState<React.RefObject<HTMLDivElement>>(null);
  return <div ref={parentRef} className={styles.connectorWrapper} data-sentry-component="ConnectorWrapper" data-sentry-source-file="connector.tsx">
      <ConnectorContext.Provider value={{
      parentRef,
      leftRef,
      setLeftRef,
      setRightRefs,
      rightRefs,
      selectedRef,
      setSelectedRef
    }} data-sentry-element="unknown" data-sentry-source-file="connector.tsx">
        <div className={styles.connectorContainer}>
          <Connectors data-sentry-element="Connectors" data-sentry-source-file="connector.tsx" />
        </div>
        <div className={styles.connectorLists}>{children}</div>
      </ConnectorContext.Provider>
    </div>;
};